import { useFormikContext } from 'formik';
import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useAchievementsContext } from '../../../../contexts/AchievementsContext/AchievementsContext';
import { ConfirmModal } from '../../../ui/ConfirmModal/ConfirmModal';
import { IAchievementModal } from '../AchievementsModalTypes';
import { useAchievementsModalContext } from '../context/AchievementsModalContext';

export function AchievementModalFooter() {
  const [showExitConfirmation, setShowExitConfirmation] = React.useState(false);

  const { isLoading } = useAchievementsContext();
  const { onHide, haveValuesChanged, isFormLoading, readOnly } = useAchievementsModalContext();

  const {
    isSubmitting, handleSubmit, values, dirty, isValid,
  } = useFormikContext<IAchievementModal[]>();

  const handleCloseButtonClick = () => {
    if (readOnly) {
      onHide();
      return;
    }
    const hasChanged = haveValuesChanged(values) || dirty;

    if (hasChanged) {
      setShowExitConfirmation(true);
    } else {
      onHide();
    }
  };

  return (
    <>
      <Modal.Footer>
        <Button
          variant="secondary"
          type="button"
          onClick={handleCloseButtonClick}
          disabled={isSubmitting || isFormLoading}
        >

          Close
        </Button>
        <Button
          variant="primary"
          type="button"
          onClick={() => handleSubmit()}
          disabled={isSubmitting || isFormLoading || isLoading || !isValid || readOnly}
        >
          {(isSubmitting || isLoading) && (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="mr-2"
          />
          )}
          Save
        </Button>
      </Modal.Footer>
      <ConfirmModal
        centered
        show={showExitConfirmation}
        isLoading={false}
        title="Exit Confirmation"
        onConfirm={onHide}
        onCancel={() => setShowExitConfirmation(false)}
        className="overlay"
        backdrop="static"
      >
        <div className="text-center">
          Are you sure you want to exit without saving?
        </div>
      </ConfirmModal>
    </>
  );
}
